import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { Dispatch } from "redux";
import { IPIC } from "redux/app/vdmdashboard/@types";
import { IStore } from "redux/store";

import SVGEmail from "components/_common/icons/vdm/SVGEmail";
import SVGContact from "components/_common/icons/vdm/SVGContact";

type OwnProps = {
	pic: IPIC;
};
type PICCardProps = PropsFromRedux & OwnProps;
function PICCard(props: PICCardProps) {
	const { pic } = props;
	const { name, department, contact, email, profilePicture } = pic;
	return (
		<div className="w-[276px] p-4 pt-0 shadow-md border border-gray-300 rounded-md">
			<div className="flex items-center justify-center ">
				<div className="bg-[#3182CE1A] p-2 text-[12px] rounded-b">
					{department}
				</div>
			</div>
			<div className="w-[242px] h-[212px] bg-gray-100 rounded-md mt-2 flex items-center justify-center">
				{profilePicture ? (
					<img
						src={profilePicture}
						alt={name}
						className="w-full h-full object-cover rounded-md"
					/>
				) : (
					<div className="bg-gray-300 border-2 border-dashed rounded-xl w-full h-full flex items-center justify-center">
						<span className="text-gray-500">No Image</span>
					</div>
				)}
			</div>
			{/* <div className="mt-2 ml-1">
				<StatusBadge status={status as any} statusLabel={statusLabel} />
			</div> */}
			<h3 className="font-medium text-lg text-gray-700">{name}</h3>
			<div className="flex items-center gap-x-2 text-gray-600 font-thin">
				<SVGEmail />
				<p>{email}</p>
			</div>
			<div className="flex items-center gap-x-2 text-gray-gray-600 font-thin">
				<SVGContact />
				<p>{contact}</p>
			</div>
		</div>
	);
}
function mapStateToProps(store: IStore, ownProps: OwnProps) {
	return {};
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
	return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(PICCard);
